import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MainHeaderContainer = styled.div`
  position: relative;
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ top, theme }) =>
    top ? theme.commons.header.zIndexMainHeader : 0};
  width: 100%;
`;

const SecondHeaderContainer = styled.div`
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ opacity, theme }) =>
    opacity > 0
      ? theme.constants.zIndex.secondHeader
      : theme.constants.zIndex.defaultHeader};
  top: 0;
  width: 100%;
  position: fixed;
  background: ${({ theme }) => theme.colors.white};
`;

class MagicHeader extends PureComponent {
  static propTypes = {
    mainHeader: PropTypes.node.isRequired,
    secondHeader: PropTypes.node.isRequired,
    calculateOpacities: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      mainHeaderOpacity: 1,
      secondHeaderOpacity: 0,
    };

    this.mainHeaderRef = React.createRef();
    this.secondHeaderRef = React.createRef();
  }

  componentDidMount() {
    this.mainHeaderHeight = this.getMainHeaderHeight();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    const { calculateOpacities } = this.props;
    if (prevProps.calculateOpacities !== calculateOpacities) {
      this.handleScroll();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  getMainHeaderHeight = () => this.mainHeaderRef?.current?.clientHeight || 0;

  handleScroll = () => {
    this.setState(this.calculateHeadersOpacities());
  };

  calculateHeadersOpacities = () => {
    const { calculateOpacities } = this.props;
    const { scrollY } = window;

    if (calculateOpacities)
      return calculateOpacities(this.mainHeaderHeight, scrollY);

    return {
      mainHeaderOpacity: 1,
      secondHeaderOpacity: scrollY > this.mainHeaderHeight ? 1 : 0,
    };
  };

  render() {
    const { mainHeader, secondHeader } = this.props;
    const { mainHeaderOpacity, secondHeaderOpacity } = this.state;

    return (
      <>
        <MainHeaderContainer
          ref={this.mainHeaderRef}
          opacity={mainHeaderOpacity}
          top={!secondHeaderOpacity}
        >
          {mainHeader}
        </MainHeaderContainer>
        <SecondHeaderContainer
          ref={this.secondHeaderRef}
          opacity={secondHeaderOpacity}
        >
          {secondHeader}
        </SecondHeaderContainer>
      </>
    );
  }
}

export default MagicHeader;
